// 默认回退语言
export const DefaultFallbackLanguage = 'en'                        
export const DefaultLanguageSettings =  [
    {name: "zh",title: "中文",default:true,active:true},
    {name: "en",title: "英文"}
] 